export default __webpack_public_path__ + "static/media/desk_krush.75044dd5.png";